import { Loader } from 'lucide-react'
import { Suspense } from 'react'
import { RootErrorBoundary } from '@/components/error-boundaries/root-error-boundary'
import { ProtectedRoute as LoggedInRoute } from '@/components/root/protected-route'
import { SuperRootContent } from '@/components/super-root/super-root'

export const SuperRoot = () => {
  return (
    <RootErrorBoundary>
      <LoggedInRoute>
        <Suspense
          fallback={
            <div className="absolute inset-0 flex items-center justify-center">
              <Loader className="text-orange-600 animate-spin size-5" />
            </div>
          }
        >
          <SuperRootContent />
        </Suspense>
      </LoggedInRoute>
    </RootErrorBoundary>
  )
}
